// extracted by mini-css-extract-plugin
export default {"emailConfirmationContainer":"EmailConfirmation_emailConfirmationContainer__rKm5g","buttonContainer":"EmailConfirmation_buttonContainer__M-Odp"};